import getters from './getters';
import actions from './actions';
import mutations from './mutations';
export var state = () => ({
  currentImage: null,
  product: null,
  productInspiration: null,
  productCross: null,
  productComplementary: null,
  variants: []
});
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};